import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalMenuService {
  showLanguageManager = new BehaviorSubject(false);
  showLanguageManager$ = this.showLanguageManager.asObservable();
  showCountryManager = new BehaviorSubject(false);
  showCountryManager$ = this.showCountryManager.asObservable();
  getUpdatedLanguage = new BehaviorSubject('');
  getUpdatedLanguage$ = this.getUpdatedLanguage.asObservable();
  constructor() { }
}
